import { BASE_BACKEND_QUERY_KEY, BASE_BACKEND_URL, QUERY_KEYS } from '../backend/constants';
import { GetCartResponse } from '../backend/openapi/api-types';
import { useAuthenticatedQuery } from '../backend/hooks/use-authenticated-query';

const cartUrls = {
  getCart: () => `${BASE_BACKEND_URL}/cart` as const,
};

export const cartQueryKeys = {
  cart: () => [BASE_BACKEND_QUERY_KEY, QUERY_KEYS.cart],
};

export const useCartQuery = () => {
  return useAuthenticatedQuery<GetCartResponse>({
    options: {
      queryKey: cartQueryKeys.cart(),
    },
    url: cartUrls.getCart(),
  });
};
